export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./languages.vue?vue&type=template&id=4c072085"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/basement/languages.vue?vue&type=template&id=4c072085
// module id = wDhg
// module chunks = 0